import { render, staticRenderFns } from "./BaseSlowConnection.vue?vue&type=template&id=419562ba&functional=true&"
import script from "./BaseSlowConnection.vue?vue&type=script&lang=ts&"
export * from "./BaseSlowConnection.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSlowConnection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports